(function () {
  /* Sections each include this script. A browser executes one <script src>
     per element, so without this guard repeated inclusion would create
     duplicate observers and double the marquee content on every render. */
  if (window.__holloraMotionInit) return;
  window.__holloraMotionInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal() {
    var items = document.querySelectorAll('[data-reveal]:not([data-reveal-bound])');
    if (!items.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.setAttribute('data-reveal-bound', ''); el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = parseInt(el.dataset.reveal, 10) || 0;
          setTimeout(function () { el.classList.add('is-in'); }, delay);
          io.unobserve(el);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.06 }
    );
    items.forEach(function (el) { el.setAttribute('data-reveal-bound', ''); io.observe(el); });
  }

  function heroVideo() {
    if (reduce) return;
    if (navigator.connection && navigator.connection.saveData) return;
    if (!('IntersectionObserver' in window)) return;

    document.querySelectorAll('[data-hero-video]:not([data-hero-bound])').forEach(function (host) {
      var video = host.querySelector('video[data-hero-src]');
      if (!video) return;
      host.setAttribute('data-hero-bound', '');
      var loaded = false;
      var inView = false;

      var play = function () {
        if (document.hidden || !inView) return;
        if (!loaded) { video.src = video.dataset.heroSrc; loaded = true; }
        video.muted = true;
        var p = video.play();
        if (p && p.then) p.then(function () { video.classList.add('is-playing'); }).catch(function () {});
        else video.classList.add('is-playing');
      };

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          inView = e.isIntersecting;
          if (inView) play();
          else if (loaded && !video.paused) video.pause();
        });
      }, { threshold: 0.25 });
      io.observe(host);

      document.addEventListener('visibilitychange', function () {
        if (!loaded) return;
        if (document.hidden) video.pause();
        else if (inView) play();
      });
    });
  }

  function marquee() {
    if (reduce) return;
    document.querySelectorAll('[data-marquee]:not([data-marquee-bound])').forEach(function (el) {
      el.setAttribute('data-marquee-bound', '');
      el.innerHTML = el.innerHTML + el.innerHTML;
    });
  }

  function run() { reveal(); heroVideo(); marquee(); }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);

  /* theme editor re-renders a section without a page load */
  document.addEventListener('shopify:section:load', run);
})();
